import { styled } from "styled-components";
import { getWaypoint } from "../../utils/api_mutex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/pro-light-svg-icons";
import WaypointType from "./WaypointType";
import Window from "../common/Window";
import { getShipBySymbol } from "../../utils/helpers";
import ShipType from "../fleet/ShipType";
import { getBounds } from "../../utils/calculations";

const Root = styled.div`
  cursor: pointer;
  left: ${props => props.$x}px;
  position: absolute;
  top: ${props => props.$y}px;
  z-index: 0;
  translate: -50% -50%;
  `;
  
  const ShipsOnWaypoint = styled(Window)`
  bottom: 0;
  display: flex;
  left: 50%;
  position: absolute;
  translate: -50% calc(100% + 2px);
  `;
  
  const Ship = styled.div`
  align-items: center;
  aspect-ratio: 1;
  background-color: ${props => props.$selected ? 'var(--color-theme-accent-500)' : 'transparent'};
  cursor: pointer;
  display: flex;
  font-size: 6px;
  justify-content: center;
  width: 16px;
  z-index: 999;
  
  &:not(:first-child) {
    border-left: var(--border);
  }
`;



function remapCoord(bounds, waypoint, x, y, place) {
  x = x * 10;
  y = y * 10;

  if (waypoint.diffX !== undefined) {
    x += waypoint.diffX;
  }

  if (waypoint.diffY !== undefined) {
    y += waypoint.diffY;
  }

  return { x , y };
}

function Waypoint({ store, waypoint, place }) {
  const state = store.state;
  const ships = store.state.ships;
  const selectedShip = state.selectedShip;
  const bounds = getBounds(store.state.system.waypoints);
  const coord = remapCoord(bounds, waypoint, waypoint.x, waypoint.y, place);
  const selected = state.waypoint && state.waypoint.symbol == waypoint.symbol;

  const clickHandle = (symbol) => {
    getWaypoint('main', state.token, symbol)
      .then((res) => {
        store.setWaypoint(res.data);
      })
      .catch((error) => {
        alert(error.message);
      });
  }

  const shipClickHandle = (symbol) => {
    store.selectShip(symbol);
  }

  return (
    <Root $x={coord.x} $y={coord.y}>
      <div onClick={() => clickHandle(waypoint.symbol)}>
        <WaypointType symbol={waypoint.symbol} type={waypoint.type} selected={selected} />
      </div>
      {waypoint.ships.length > 0 && (
        <ShipsOnWaypoint>
          { waypoint.ships.length > 0 && waypoint.ships.slice(0,4).map((ship, idx) => (
            <Ship key={idx} title={ship} $selected={ship == selectedShip} onClick={() => shipClickHandle(ship)}>
              <ShipType ship={getShipBySymbol(ship, ships && ships)} />
            </Ship>
          ))}
          { waypoint.ships.length > 4 &&
            <Ship onClick={() => store.setModal('fleet')}>
              <FontAwesomeIcon icon={faEllipsisH} />
            </Ship>
          }
        </ShipsOnWaypoint>
      )}
    </Root>
  );
}

export default Waypoint;
